export default "__VITE_ASSET__BREBRVV8__"